import { Formik, FormikHelpers } from "formik";
import React, { useMemo } from "react";
import { Button } from "~/components/Button";

import { Form, FormControls, FormRow, FormTitle, IntentText } from "~/components/Form";
import { IModalComponent, IModalComponentClose } from "~/components/Modal";
import { Intent } from "~/lib/intent";
import { getReleaseIntervalStatusLabel, IReleaseInterval } from "~/modules/Clients/models/AccountInfo";
import { Table } from "~/components/Table";
import { stringDateFormat } from "~/lib/date";
import { FormNotice } from "~/components/FormNotice/FormNotice";
import { getGranularityDateFormat } from "~/modules/Dashboard/lib/performance";
import { Granularity } from "~/modules/Dashboard/models/Performance";

interface IForceReleaseFrom {
  sellerName: string;
  unreleasedIntervals: IReleaseInterval[];
  onSubmit: (formikActions: FormikHelpers<never[]>, close?: IModalComponentClose) => void;
}

export const ForceReleaseForm: IModalComponent<IForceReleaseFrom> = (props) => {
  const dailyDateFormat = getGranularityDateFormat(Granularity.DAILY);

  return (
    <Formik initialValues={[]} onSubmit={(_data, actions) => props.onSubmit(actions, props.close)}>
      {(formik) => {
        const { status, isSubmitting } = formik;
        return (
          <Form>
            <FormTitle>Force release intervals for {props.sellerName}</FormTitle>

            {status && <IntentText intent={Intent.DANGER}>{status}</IntentText>}
            <FormNotice message="When you delete payment in Trolley you need to force release intervals here to synchronize state." />
            <Table
              header
              columns={[
                {
                  header: "Release ID",
                  field: "releaseId",
                },
                {
                  header: "Start",
                  cell: (interval) => stringDateFormat(interval.interval.start, dailyDateFormat),
                },
                {
                  header: "End",
                  cell: (interval) => stringDateFormat(interval.interval.end, dailyDateFormat),
                },
                {
                  header: "Status",
                  cell: (interval) => getReleaseIntervalStatusLabel(interval.status),
                },
              ]}
              records={props.unreleasedIntervals}
            />

            <FormControls>
              <Button disabled={isSubmitting} onClick={props.close}>
                Cancel
              </Button>
              <Button
                type="submit"
                disabled={isSubmitting}
                intent={Intent.PRIMARY}
                rightIcon={isSubmitting && <i className="fa fa-spinner fa-spin" />}
              >
                Force release
              </Button>
            </FormControls>
          </Form>
        );
      }}
    </Formik>
  );
};
